import firebase from 'firebase';
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyAqsN4Rf0X5GvlCBdYPkgBT6Wnr3qKy8gY',
  authDomain: 'hydrafacial-b68c2.firebaseapp.com',
  databaseURL: 'https://hydrafacial-b68c2.firebaseio.com',
  projectId: 'hydrafacial-b68c2',
  storageBucket: 'hydrafacial-b68c2.appspot.com',
  messagingSenderId: '1041408772057'
};
const firebaseapp = firebase.initializeApp(config);
firebaseapp.firestore().settings({  });
export default firebaseapp.firestore();
